export default __webpack_public_path__ + "media/flags/tn-08449c29.svg";